<template>
    <div>
        <validation-observer #default="{ invalid }" ref="observer">
            <span class="display-none">{{ invalid }}</span>
            <b-form ref="formular">
                <div class="white-box mt-3">
                    <div class="data-group">
                        <M3FormTitle title="Titlul proiectului" :checked="completed"></M3FormTitle>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            name="denumire companie"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                class="custom-responsive"
                                label-cols-sm="2"
                                label-cols-lg="2"
                                content-cols-sm
                                content-cols-lg="10"
                                label="Titlul proiectului"
                            >
                                <b-form-input
                                    id="name"
                                    v-model="form.title"
                                    type="text"
                                    name="message"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>

                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box mt-3"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </div>
                </div>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BIconCheckCircleFill, BIconXCircleFill, BFormRadioGroup } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import M3FormTitle from '../M3FormTitle'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            M3FormTitle,
            BIconCheckCircleFill,
            BIconXCircleFill,
            BFormRadioGroup,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            projectTitle: null,
        },
        data() {
            return {
                currentM3CompanyCui: JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).id : 0,
                form: {
                    title: 'Investiții în activități productive pentru '+JSON.parse(localStorage.getItem('currentM3Company')).name,
                },
                completed: false,
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch:{
            projectTitle: {
                handler: function() {
                    if(this.projectTitle){
                        this.form.title = this.projectTitle
                        this.completed = true
                        this.$emit('formComplete')
                    } else {
                        this.form.title = 'Investiții în activități productive pentru ' + JSON.parse(localStorage.getItem('currentM3Company')).name
                        this.$emit('formIncomplete')
                    }
                },
                deep: false
            },
            checks: {
                handler: function() {
                    this.completed = this.checks.proiectulMeuTitlu;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.projectTitle){
                this.form.title = this.projectTitle
                this.completed = true
                this.$emit('formComplete')
            } else {
                this.form.title = 'Investiții în activități productive pentru ' + (JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).name : '')
                this.$emit('formIncomplete')
            }
        },

        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{
                        if(this.completed){
                            let formSend = {
                                mysmis: {
                                    title: this.form.title,
                                    code: null
                                }
                            }
                            this.$store.dispatch('m3Sketch/saveAllDataProjectPart', formSend)
                                .then((response) => {
                                    this.$toast.success(response.data)
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }
                    }
                    if(this.checks.proiectulMeuTitlu !== this.completed)
                        this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuTitlu', value: this.completed })
                })
            }
        }
    }
</script>

<style scoped>
.text-danger{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    white-space: pre;
    top: 0;
    bottom: 0;
    margin: auto;
    align-items: center;
    right: 20px;
}
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.first-input{
    width: 47%;
}
.second-input{
    width: 48%;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 85%;
}
.switch-box{
    text-align: right;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.form-group >>> legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.select-input >>> select{
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
    border-radius: 2px;
    max-width: 170px;
    margin-right: 10px;
    margin-bottom: 0;
}
.imm > select {
    min-width: 100%;
    margin-right: 0;
}
.select-input >>> .disabled-select{
    background: #a1fff1;
    opacity: 1;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: center;
}
.inline-inputs{
    display: flex;
}
.inline-inputs input:first-child, .inline-inputs div:first-child{
    width: 25%;
    margin-right: 10px;
}
.inline-inputs div:first-child input{
    width: 100%;
}
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 0.3;
}
.termene-icon{
    position: absolute;
    bottom: 15px;
    left: 20px;
}
.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    max-height: 33px;
    border-radius: 2px;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
</style>
